type SessionExpiryListener = () => void;

const listeners = new Set<SessionExpiryListener>();
let sessionExpired = false;

export const notifySessionExpired = () => {
  sessionExpired = true;

  for (const listener of listeners) {
    try {
      listener();
    } catch (error) {
      // Ensure one faulty listener does not prevent others from being notified
      console.error("Error while notifying session expiry listener:", error);
    }
  }
};

export const subscribeSessionExpired = (listener: SessionExpiryListener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isSessionExpired = () => {
  return sessionExpired;
};

export const resetSessionExpired = () => {
  sessionExpired = false;
};
